import React, { useState } from "react";
import { images } from "../../constants";
import { client } from "../../client";
import { NavigationDots, SocialMedia } from "../../components";
import { motion } from "framer-motion";

import "./Contact.scss";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: "contact",
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    fetch("https://getform.io/f/eb1c7383-14eb-4e41-8244-fc82aa758b06", {
      method: "POST",
      body: JSON.stringify({
        name: formData.username,
        email: formData.email,
        message: formData.message,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then()
      .catch((err) => console.log(err));

    client
      .create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div id="contact" className="app__container app__primarybg">
        <SocialMedia />
        <div className="app__wrapper app__flex">
          <motion.div
            whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
            transition={{ duration: 0.5 }}
            className={`app__contact app__flex`}
          >
            <h2 className="head-text contact-head">
              Take a coffee & chat with me
            </h2>

            <div className="app__contact-cards">
              <div className="app__contact-card ">
                <img src={images.email} alt="email" />
                <a href="mailto:sam99sumeet@gmail.com" className="p-text">
                  sam99sumeet@gmail.com
                </a>
              </div>
              <div className="app__contact-card">
                <img src={images.mobile} alt="phone" />
                <a href="tel:+918767956476" className="p-text">
                  +918767956476
                </a>
              </div>
            </div>
            {!isFormSubmitted ? (
              <div className="app__contact-form app__flex">
                <div className="app__flex">
                  <input
                    className="p-text"
                    type="text"
                    placeholder="Your Name"
                    name="username"
                    value={username}
                    onChange={handleChangeInput}
                  />
                </div>
                <div className="app__flex">
                  <input
                    className="p-text"
                    type="email"
                    placeholder="Your Email"
                    name="email"
                    value={email}
                    onChange={handleChangeInput}
                  />
                </div>
                <div>
                  <textarea
                    className="p-text"
                    placeholder="Your Message"
                    value={message}
                    name="message"
                    onChange={handleChangeInput}
                  />
                </div>
                <button type="button" className="p-text" onClick={handleSubmit}>
                  {!loading ? "Send Message" : "Sending..."}
                </button>
              </div>
            ) : (
              <div>
                <h3 className="head-text">Thank you for getting in touch!</h3>
              </div>
            )}
          </motion.div>
        </div>
        <NavigationDots active="contact" />
      </div>
    </>
  );
};

export default Contact;
